/* global __CLIENT__ */

let clientConfig;
if (__CLIENT__) {
  clientConfig = window.__CONFIG__;
} else {
  clientConfig = require('../../server/config/client'); // eslint-disable-line global-require
}

export default clientConfig;



// WEBPACK FOOTER //
// ./app/config/index.js